import { useState, useCallback } from 'react';

const LANGUAGES = [
  { code: 'sw', name: 'Swahili', flag: '🇰🇪' },
  { code: 'yo', name: 'Yoruba', flag: '🇳🇬' },
  { code: 'zu', name: 'Zulu', flag: '🇿🇦' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬' },
  { code: 'am', name: 'Amharic', flag: '🇪🇹' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬' },
  { code: 'tw', name: 'Twi', flag: '🇬🇭' },
  { code: 'ln', name: 'Lingala', flag: '🇨🇩' },
  { code: 'rw', name: 'Kinyarwanda', flag: '🇷🇼' },
  { code: 'lg', name: 'Luganda', flag: '🇺🇬' },
  { code: 'xh', name: 'Xhosa', flag: '🇿🇦' },
  { code: 'so', name: 'Somali', flag: '🇸🇴' },
  { code: 'en', name: 'English', flag: '🌍' },
  { code: 'fr', name: 'French', flag: '🌍' },
  { code: 'ar', name: 'Arabic', flag: '🇪🇬' },
  { code: 'pt', name: 'Portuguese', flag: '🇦🇴' },
];

export { LANGUAGES };

async function callClaude(messages, system) {
  const res = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ model: 'claude-sonnet-4-20250514', max_tokens: 1000, system, messages })
  });
  const data = await res.json();
  return data.content?.[0]?.text || '';
}

export function useAIChat() {
  const [messages, setMessages] = useState([{
    role: 'assistant',
    content: "Oli otya! I am Umoja AI. I speak 16 African languages and can translate, write captions, and help you connect with African creators. What would you like to do?"
  }]);
  const [loading, setLoading] = useState(false);

  const sendMessage = useCallback(async (text) => {
    const newMessages = [...messages, { role: 'user', content: text }];
    setMessages(newMessages);
    setLoading(true);
    try {
      const result = await callClaude(
        newMessages.map(m => ({ role: m.role, content: m.content })),
        `You are Umoja AI, the assistant for Umoja — Africa's social media platform built in Uganda.
         Help with: translating between African languages (Swahili, Yoruba, Luganda, Zulu, Hausa, Amharic, Igbo, Twi, Lingala, Kinyarwanda, Xhosa, Somali and more),
         writing social media captions, African cultural insights, trending topics, creator discovery.
         Be warm, culturally informed, use occasional African greetings naturally. Keep responses concise.`
      );
      setMessages(prev => [...prev, { role: 'assistant', content: result }]);
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'Oops! Something went wrong. Try again!' }]);
    } finally {
      setLoading(false);
    }
  }, [messages]);

  return { messages, loading, sendMessage };
}
